import React, {Component} from 'react'
//import ContextMenu from '../../FunctionArea/ContextMenu'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import WarningDialog from '../../FunctionArea/WarningDialog'
import SmallNotification from '../../FunctionArea/SmallNotification'
import {server_ip} from '../../../ipAddress'
import './EventSchedulerBody.css'
import './coreMain.css'
import './dayGridMain.css'




class EventSchedulerBody extends Component {
    constructor(props) {
        super(props)
        this.state = {
            year:null,
            month:null,
            date:null,
            day:null,
            fullScreen:false,
            showWarningDialog:false,
            showSmallNotification:false,
            showEventInfo:null,
            eventHover:false,
            mousePos:null,
        }
        this.calendarComponentRef = React.createRef();
    }

    componentDidMount(){
        //this.getDate()
    }

    getEventDate=async(fetchInfo,successCallback,failureCallback)=>{
        let startDate = fetchInfo.start.toISOString().slice(0, 19).replace('T', ' ')
        let endDate = fetchInfo.end.toISOString().slice(0, 19).replace('T', ' ')
        let msg = await fetch(server_ip+'/api/event/fetch/EventMainInfoByDate/'+startDate+'/'+endDate)

        let output = await msg.json()
        successCallback(
            output.map(event=>{
                let hexColor = "#"+this.getHashColor(event.Event_SysID)
                let eventObj = {
                    id:event.Event_SysID,
                    title:event.Event_Title,
                    start:event.Event_StartDate,
                    end:event.Event_EndDate,
                    backgroundColor:hexColor,
                    borderColor:hexColor
                }
                //console.log(eventObj)
                return eventObj
            })
        )
        //console.log(output)
    }

    getHashColor=(str)=> {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
           hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        //console.log(hash)
        let c = (hash & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
        return "00000".substring(0, 6 - c.length) + c;
    } 
    

    divKeyDown=(e)=>{
        console.log("divKeyDown")
        if(e.ctrlKey === true && e.key === 'q')
        {
            console.log("ctrl key and f key been pressed")
            this.setState(prevState=>({
                fullScreen:!prevState.fullScreen
            }))
        }
    }

    fullScreenBoxOnClick = (e) => {
        e.stopPropagation()
        this.setState(prevState=>({
            fullScreen:!prevState.fullScreen
        }))
    }

    divOnClick=()=>{
        console.log('divOnClick')
        this.setState({
            showSmallNotification:false,
            showEventInfo:null,
            mousePos:null
        })
    }

    confirmChange=()=>{
        console.log('confirmChange...')
    }

    cancelChange=()=>{
        console.log('cancelChange...')
    }

    getCalendarHeight=()=>{
        console.log('getCalendarHeight...')
        if(this.state.fullScreen)
        {
            console.log("A1")
            return 800
        }
        else
        {
            console.log("A2")
            return 230
        }
    }

    eventRender=(event,element,view)=>{
        element.attr('dataid',event._id)
    }

    eventMouseEnter=(info)=>{
        //console.log("eventMouseEnter...")
        let dataid = info.event.id
        let eventArray = document.querySelectorAll(".event"+dataid)
        //console.log(".event"+dataid)
        //console.log(eventArray)
        eventArray.forEach(event=>{
            event.style.backgroundColor = "#bfbfbf"
            event.style.borderColor = "#bfbfbf"
        })
        info.el.style.cursor = "pointer"
    }

    eventMouseLeave=(info)=>{
        //console.log("eventMouseLeave...")
        let dataid = info.event.id
        let hexColor = this.getHashColor(dataid)
        let eventArray = document.querySelectorAll(".event"+dataid)
        //console.log(".event"+dataid)
        //console.log(eventArray)
        eventArray.forEach(event=>{
            event.style.backgroundColor = "#"+hexColor
            event.style.borderColor = "#"+hexColor
        })
        info.el.style.cursor = "default"
    }

    eventClick=(info)=>{
        console.log("title : ", info.event.title)
        console.log("start : ", info.event.start)
        console.log("end : ", info.event.end)
        let output = {
            Event_SysID:info.event.id,
            Event_Title:info.event.title,
            Event_StartDate:info.event.start,
            Event_EndDate:info.event.end
        }

  
        this.setState({
            showSmallNotification:true,
            showEventInfo:output,
            mousePos:{
                x:info.jsEvent.pageX,
                y:info.jsEvent.pageY
            }
        })    
    }

    eventRender=(info)=>{
        //console.log(info.el)
        //info.el.setAttribute("data-id", info.event.id)
        info.el.classList.add("event"+info.event.id)
    }

    getSelectedEvent=(msg)=>{
        this.props.getSelectedEvent(msg)
    }

    render(){
        console.log("EventSchedulerBody Render...")
        let parentFullScreen = {
            all:'unset',
            position:'relative',
        }

        let parentNotFullScreen = {
            position:'relative',
        }

        let childFullScreen = {
            width:'100vw',
            height:'100vh',
            position:'fixed',
            left:'0',
            top:'0',
            zIndex:'2000',
            backgroundColor:'white'    
        }

        let childNotFullScreen = {
            backgroundColor:'white',
            height:"230px",
            //overflow:"scroll"
        }

        let fullScreenSymbol = "☐"
        let notFullScreenSymbol = "_"
    
        return(
            <div style={this.state.fullScreen? parentFullScreen:parentNotFullScreen} onKeyDown={this.divKeyDown} onClick={this.divOnClick} tabIndex='0'>
                <div style={this.state.fullScreen? childFullScreen:childNotFullScreen}> 
                    <WarningDialog from={"EventListBody"} showWarningDialog={this.state.showWarningDialog} confirm={this.confirmChange} cancel={this.cancelChange}/>
                    <div className ={"rightTopBoxArea"}>
                        <div className = {"rightTopBox"} onClick={this.fullScreenBoxOnClick}>{this.state.fullScreen? notFullScreenSymbol:fullScreenSymbol}</div>
                    </div>     
                    {this.state.showSmallNotification? <SmallNotification eventInfo={this.state.showEventInfo} pos={this.state.mousePos} getSelectedEvent={this.getSelectedEvent}/> :null}         
                    <FullCalendar defaultView="dayGridMonth" 
                        ref={this.calendarComponentRef}
                        header={{
                            left: "prev,next today",
                            center: "title",
                            right: ""
                            }} 
                        plugins={[ dayGridPlugin ]} 
                        eventClick={this.eventClick}
                        eventRender={this.eventRender}
                        eventMouseEnter={this.eventMouseEnter}
                        eventMouseLeave={this.eventMouseLeave}

                        events={(fetchInfo,successCallback,failureCallback)=>{this.getEventDate(fetchInfo,successCallback,failureCallback)}}
                        height={this.getCalendarHeight()}                      
                    />
                </div>
            </div>
        )
    }

}

export default EventSchedulerBody